import React, { useState } from "react";
import logo from "../assets/images/background.png";

type OrderType = {
  address_info: [
    {
      address: "";
      building_name: "";
      city_id: "";
      floor: "";
      id: "";
      lang: "";
      lat: "";
      mobile: "";
      mtm: "";
      muid: "";
      postal_code: "";
      province_id: "";
      status: "";
      title: "";
      unit: "";
      uptm: "";
      upuid: "";
      user_id: "";
    }
  ];
  all_item_count: "";
  avb_product_count: "";
  customer_description: "";
  id: "";
  item_count: "";
  items: [
    {
      avb_product_for_order_id: "";
      discount: "";
      filename: null;
      files__id: null;
      item_count: "";
      mtm: "";
      muid: "";
      order_id: "";
      order_items__id: "";
      path: null;
      pic_file_id: "";
      product_description: "";
      product_id: "";
      product_price: "";
      product_title: "";
      rto_basket_id: "";
      selected_aoos: "";
      supplier_id: "";
      total_price: "";
      uid: "";
      uptm: "";
      upuid: "";
      weight_from: "";
      weight_to: "";
    }
  ];
  lats_order_status: "";
  mtm: "";
  muid: "";
  paid_amount: "";
  pay_type: "";
  rto_basket_count: "";
  status_log: "";
  superadmin_description: "";
  suppliers_description: "";
  total_discount: "";
  total_price: "";
  uid: "";
  uptm: "";
  upuid: "";
  user_address_id: "";
  user_info: [
    {
      account_changes: "";
      address: "";
      bdday: "";
      bdmonth: "";
      bdtm: "";
      bdyear: "";
      codemeli: "";
      filename: "";
      files__id: "";
      fullname: "";
      has_active_order: "";
      has_cart_item: "";
      is_admin: "";
      is_bike_delivery: "";
      is_supplier: "";
      main_status: "";
      mobile: "";
      mtm: "";
      muid: "";
      path: "";
      profile_pic_file_id: "";
      refer_from_uid: "";
      tell: "";
      uptm: null;
      upuid: null;
      users__id: "";
    }
  ];
};

const AdminOrdersContext: {
  orders: OrderType[];
  orderDetail: OrderType;
  show: boolean;
  editShow: boolean;
  changeShow: (state: boolean) => void;
  selectOrder: (order: OrderType, isEdit: boolean) => void;
} = React.createContext({
  // orders: [
  //   {
  //     fullname: "",
  //     orderNumber: 0,
  //     address: "",
  //     mobile: "",
  //     status: 0,
  //     time: 0,
  //     mtm: 0,
  //     price: 0,
  //     items: [{ title: "", count: 0, price: 0, logo: "", cover_img: "" }],
  //   },
  // ],
  orders: [],
  orderDetail: {
    fullname: "",
    orderNumber: 0,
    address: "",
    mobile: "",
    status: 0,
    time: 0,
    mtm: 0,
    price: 0,
    // items: [{ title: "", count: 0, price: 0, logo: "", cover_img: "" }],
    items: [],
  },
  show: false,
  editShow: false,
  changeShow: (state: boolean) => {},
  selectOrder: (order: OrderType, isEdit: boolean) => {},
});

export default AdminOrdersContext;

export const AdminOrdersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [show, setShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [orders, setOrders] = useState([
    // {
    //   address_info: [
    //     {
    //       address: "",
    //       building_name: "",
    //       city_id: "",
    //       floor: "",
    //       id: "",
    //       lang: "",
    //       lat: "",
    //       mobile: "",
    //       mtm: "",
    //       muid: "",
    //       postal_code: "",
    //       province_id: "",
    //       status: "",
    //       title: "",
    //       unit: "",
    //       uptm: "",
    //       upuid: "",
    //       user_id: "",
    //     },
    //   ],
    //   all_item_count: "",
    //   avb_product_count: "",
    //   customer_description: "",
    //   id: "",
    //   item_count: "",
    //   items: [
    //     {
    //       avb_product_for_order_id: "",
    //       discount: "",
    //       filename: null,
    //       files__id: null,
    //       item_count: "",
    //       mtm: "",
    //       muid: "",
    //       order_id: "",
    //       order_items__id: "",
    //       path: null,
    //       pic_file_id: "",
    //       product_description: "",
    //       product_id: "",
    //       product_price: "",
    //       product_title: "",
    //       rto_basket_id: "",
    //       selected_aoos: "",
    //       supplier_id: "",
    //       total_price: "",
    //       uid: "",
    //       uptm: "",
    //       upuid: "",
    //       weight_from: "",
    //       weight_to: "",
    //     },
    //   ],
    //   lats_order_status: "",
    //   mtm: "",
    //   muid: "",
    //   paid_amount: "",
    //   pay_type: "",
    //   rto_basket_count: "",
    //   status_log: "",
    //   superadmin_description: "",
    //   suppliers_description: "",
    //   total_discount: "",
    //   total_price: "",
    //   uid: "",
    //   uptm: "",
    //   upuid: "",
    //   user_address_id: "",
    //   user_info: [
    //     {
    //       account_changes: "",
    //       address: "",
    //       bdday: "",
    //       bdmonth: "",
    //       bdtm: "",
    //       bdyear: "",
    //       codemeli: "",
    //       filename: "",
    //       files__id: "",
    //       fullname: "",
    //       has_active_order: "",
    //       has_cart_item: "",
    //       is_admin: "",
    //       is_bike_delivery: "",
    //       is_supplier: "",
    //       main_status: "",
    //       mobile: "",
    //       mtm: "",
    //       muid: "",
    //       path: "",
    //       profile_pic_file_id: "",
    //       refer_from_uid: "",
    //       tell: "",
    //       uptm: null,
    //       upuid: null,
    //       users__id: "",
    //     },
    //   ],
    // },
  ]);
  // console.log("orders :>> ", orders);

  const [orderDetail, setOrderDetail] = useState<OrderType>({
    address_info: [
      {
        address: "",
        building_name: "",
        city_id: "",
        floor: "",
        id: "",
        lang: "",
        lat: "",
        mobile: "",
        mtm: "",
        muid: "",
        postal_code: "",
        province_id: "",
        status: "",
        title: "",
        unit: "",
        uptm: "",
        upuid: "",
        user_id: "",
      },
    ],
    all_item_count: "",
    avb_product_count: "",
    customer_description: "",
    id: "",
    item_count: "",
    items: [
      {
        avb_product_for_order_id: "",
        discount: "",
        filename: null,
        files__id: null,
        item_count: "",
        mtm: "",
        muid: "",
        order_id: "",
        order_items__id: "",
        path: null,
        pic_file_id: "",
        product_description: "",
        product_id: "",
        product_price: "",
        product_title: "",
        rto_basket_id: "",
        selected_aoos: "",
        supplier_id: "",
        total_price: "",
        uid: "",
        uptm: "",
        upuid: "",
        weight_from: "",
        weight_to: "",
      },
    ],
    lats_order_status: "",
    mtm: "",
    muid: "",
    paid_amount: "",
    pay_type: "",
    rto_basket_count: "",
    status_log: "",
    superadmin_description: "",
    suppliers_description: "",
    total_discount: "",
    total_price: "",
    uid: "",
    uptm: "",
    upuid: "",
    user_address_id: "",
    user_info: [
      {
        account_changes: "",
        address: "",
        bdday: "",
        bdmonth: "",
        bdtm: "",
        bdyear: "",
        codemeli: "",
        filename: "",
        files__id: "",
        fullname: "",
        has_active_order: "",
        has_cart_item: "",
        is_admin: "",
        is_bike_delivery: "",
        is_supplier: "",
        main_status: "",
        mobile: "",
        mtm: "",
        muid: "",
        path: "",
        profile_pic_file_id: "",
        refer_from_uid: "",
        tell: "",
        uptm: null,
        upuid: null,
        users__id: "",
      },
    ],
  });

  function changeShow(state = !show) {
    setShow(state);
    if (state === false && editShow === true) {
      setEditShow(false);
    }
  }

  function selectOrder(order: OrderType, isEdit = false) {
    setOrderDetail(order);
    changeShow(true);
    if (isEdit === true) {
      setEditShow(true);
    }
  }
  // console.log("orderdetailscontext", orderDetail);
  return (
    <AdminOrdersContext.Provider
      value={{
        orders,
        orderDetail,
        show,
        editShow,
        changeShow,
        selectOrder,
        setOrders,
      }}
    >
      {children}
    </AdminOrdersContext.Provider>
  );
};

export type { OrderType };
